<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 16:28:50
 * @LastEditTime: 2020-06-21 15:41:42
 * @Description: 考生答题详情
 -->
<template>
  <div v-if="loaded" class="content">
    <examinee-info :examinee-info="examineeInfo" />
    <questions
      :status="status"
      :answer-detail="answerDetail"
      :maker="examineeInfo.maker"
      :old-total-score="examineeInfo.score ? examineeInfo.score : ''"
      @repull-info="repullInfoHandler"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import ExamineeInfo from './components/ExamineeInfo.vue';
import Questions from './components/Questions.vue';

export default {
  name: 'ExamAnswerDetail',
  components: {
    ExamineeInfo,
    Questions,
  },
  data() {
    return {
      loaded: false,
      examineeInfo: {
        branchName: '',
        branchRank: 0,
        rank: 0,
        score: 0,
        subBranchName: '',
        userCode: '',
        userName: '',
        userType: '',
        maker: true,
      },
      answerDetail: [],
      status: '',
    };
  },
  computed: {
    ...mapGetters({
      breadcrumbList: 'pageStore/breadcrumb',
    }),
    paperId() {
      return this.$route.query.paperId;
    },
    userCode() {
      return this.$route.query.userCode;
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
    }),
    /**
     * 重新拉取考生信息处理函数
     */
    repullInfoHandler() {
      this.requestPersonAnswerBaseInfoAndSetting();
    },
    /**
     * 请求考生答题基本信息并设置
     */
    requestPersonAnswerBaseInfoAndSetting() {
      this.requestPersonAnswerBaseInfo()
        .then((result) => {
          this.examineeInfo = result;
          if (result.status) {
            this.status = result.status;
          } else {
            this.status = '';
          }
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求考生答题基本信息
     */
    requestPersonAnswerBaseInfo() {
      const params = {
        paperId: this.paperId,
        userCode: this.userCode,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperDetailPersonInfo(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 并发请求此页面首屏展示所有数据
     */
    concurrentRequestThisPageData() {
      const params = {
        paperId: this.paperId,
        userCode: this.userCode,
      };

      axios.all([
        this.$http.examcenter.paperDetailPersonInfo(params),
        this.$http.examcenter.paperDetailAnswerDetail(params),
      ])
        .then(axios.spread((personInfo, answerDetail) => {
          if (personInfo.code === '200') {
            this.examineeInfo = personInfo.data;

            if (personInfo.data.status) {
              this.status = personInfo.data.status;
            } else {
              this.status = '';
            }
          }

          if (answerDetail.code === '200') {
            this.answerDetail = answerDetail.data;
          }

          if (personInfo.code === '200' && answerDetail.code === '200') {
            this.loaded = true;

            this.setProcessingShowState({ show: false });
          } else {
            alert('获取数据失败');
            this.loaded = true;
            this.setProcessingShowState({ show: false });
          }
        }));
    },
    /**
     * 设置面包屑导航路径
     */
    setBreadcrumbHref() {
      const list = JSON.parse(JSON.stringify(this.breadcrumbList));
      if (list.length > 0) {
        const prevUrl = document.referrer;
        const splitUrl = prevUrl.split('/');
        const paperId = splitUrl[splitUrl.length - 1];

        list[3].href = `/examcentersite/#/paper/detail/${paperId}`;

        list.push({ text: '答题明细' });
      } else {
        const breadcrumb = [
          { text: '统考中心', href: '/tr/portal/index.jsp' },
          { text: '分数统计', href: '/mvc/exam/statistic/query?smId=4006' },
          { text: '答题明细' },
        ];
        this.setBreadcrumb({ breadcrumb });
      }
    },
  },
  created() {
    this.setBreadcrumbHref();

    this.setProcessingShowState({ show: true });

    this.concurrentRequestThisPageData();
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 20px;
  margin-bottom: 0;

  /deep/ .ivu-input {
    &:focus {
      border-color: #dcdee2;
      box-shadow: none;
    }

    &:hover {
      border-color: #dcdee2;
    }
  }
}
</style>
